import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function ageRangeValidator(min = 18, max = 99): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value == null || isNaN(value)) return { ageInvalid: true };
    if (value < min || value > max)
      return { ageOutOfRange: { min, max, actual: value } };

    return null; // valido
  };
}
